module.exports = __webpack_public_path__ + "static/media/eple_brown-min.692248fa.png";